var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-container"},[_c('img',{attrs:{"src":_vm.logo}}),_c('h1',[_vm._v("Website currently under maintainence.")]),_c('h1',[_vm._v("Please hold on...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }